module.exports = __webpack_public_path__ + "static/Compute-Software-Subprocessors-42e33a01059da5c3d9104ce895979766.pdf";